import { useEffect } from "react"

const useInteractionObserver = (targetRef, containerRef, callback) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        callback(entry.isIntersecting)
      },
      { threshold: 0.1, root: containerRef.current, rootMargin: "0px" }
    )
    if (targetRef.current) {
      observer.observe(targetRef.current)
    }
    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current)
      }
    }
  }, [callback])
}

export default useInteractionObserver
